export const AUDIUS_ACCOUNT_KEY = '@audius/account'
export const AUDIUS_ACCOUNT_USER_KEY = '@audius/audius-user'
export const AUDIUS_USER_WALLET_OVERRIDE_KEY = '@audius/user-wallet-override'
export const IS_MOBILE_USER_KEY = 'is-mobile-user'
